import {
  type FileDownloadUrl,
  type OrgQuotaList,
  type OrgStorageView,
  type PortfolioStorage,
  type ProjectFilesView,
} from '@apm/contracts';
import { apiFetch } from '../../lib/http';

/** Trang Files của dự án và dung lượng theo dự án — APM-FILES-a/b/c. */
export const projectFilesApi = {
  list: (projectId: string) => apiFetch<ProjectFilesView>(`/projects/${projectId}/files`),

  remove: (projectId: string, fileId: string) =>
    apiFetch<void>(`/projects/${projectId}/files/${fileId}`, { method: 'DELETE' }),

  /** Presigned GET — file không bao giờ đi qua Node (luật #3). */
  downloadUrl: (fileId: string) => apiFetch<FileDownloadUrl>(`/files/${fileId}/url`),

  /** Tổ chức đang mở — quản trị tổ chức (APM-QUOTA-a). */
  orgStorage: () => apiFetch<OrgStorageView>('/org/storage'),

  /** Mọi tổ chức — quản trị hệ thống. */
  orgQuotas: () => apiFetch<OrgQuotaList>('/admin/org-storage'),

  setOrgQuota: (orgId: string, quotaBytes: number) =>
    apiFetch<OrgQuotaList>(`/admin/org-storage/${orgId}`, {
      method: 'PUT',
      body: { quotaBytes },
    }),

  portfolio: (asOf?: string) =>
    apiFetch<PortfolioStorage>(
      `/portfolio/storage${asOf ? `?asOf=${encodeURIComponent(asOf)}` : ''}`,
    ),
};

/**
 * Dưới `['projects', id]` nên mọi chỗ làm mới dự án cũng làm mới danh sách
 * file; tải lên hay gỡ đính kèm ở chỗ khác thì trang Files đọc lại khi mở.
 */
export const projectFilesKeys = {
  list: (projectId: string) => ['projects', projectId, 'files'] as const,
  portfolio: (asOf?: string) => ['portfolio', 'storage', asOf ?? null] as const,
  orgStorage: ['admin', 'org-storage', 'mine'] as const,
  orgQuotas: ['admin', 'org-storage', 'all'] as const,
};
